module.exports = __webpack_public_path__ + "img/guinness-world-records.f2a9017f.png";